import { UNKNOWN_PARTNER } from 'src/constants/ApiConstants';

const PARTNER_QUERY_PARAM = 'partner';

const ALLOWED_PARTNER = /^[\w .&-]{1,128}$/;

export const sanitizePartner = (partner: string | null): string => {
  const trimmed = partner?.trim();
  return trimmed && ALLOWED_PARTNER.test(trimmed) ? trimmed : UNKNOWN_PARTNER;
};

/**
 * Reads partner attribution from the current URL.
 */
export const getPartner = (): string =>
  sanitizePartner(
    new URLSearchParams(window.location.search).get(PARTNER_QUERY_PARAM),
  );
